import { GameLobby } from "@/features/rooms/components/GameLobby.tsx";

export const QuizLobby = (
  { user }: {
    user?: {
      id: string;
      name?: string;
      reservedRooms?: any[];
      isAnonymous?: boolean;
    };
  },
) => {
  const showAdminLink = user && !user.isAnonymous;

  return (
    <div>
      <GameLobby
        title="THE FARM QUIZ"
        description="Compete in a fast-paced trivia buzzer game."
        wsUrl="/ws/quiz"
        createUrl="/api/quiz/rooms"
        joinUrlPrefix="/quiz"
        user={user}
        buttonText="Start New Game"
        showReserved
      />
      {showAdminLink && (
        <div class="fixed bottom-4 right-4">
          <a
            href="/admin/quiz"
            class="btn btn-ghost btn-sm opacity-60 hover:opacity-100"
          >
            Manage Questions
          </a>
        </div>
      )}
    </div>
  );
};
